import { useCallback } from "react";
import type { SendEmailFormData } from "@/components/shared/formElements/SendEmailForm";
import { toSendEmailTaskParameters } from "@/features/email/utils/send-email-task-parameters";
import {
  APPOINTMENT_TASK_ACTIONS,
  APPOINTMENT_TASK_ENTITY,
} from "@/features/tasks/constants";
import { useCreateTask } from "@/features/tasks/hooks";

export function useAppointmentTaskSubmit() {
  const { createTaskAsync, isPending } = useCreateTask();

  const submitSendEmail = useCallback(
    async (appointmentIds: number[], data: SendEmailFormData) => {
      await createTaskAsync({
        entityName: APPOINTMENT_TASK_ENTITY,
        actionName: APPOINTMENT_TASK_ACTIONS.sendEmail,
        selectedIds: appointmentIds,
        executionParameters: toSendEmailTaskParameters(data),
        files: data.attachments,
      });
    },
    [createTaskAsync],
  );

  const submitDeactivate = useCallback(
    async (appointmentIds: number[]) => {
      await createTaskAsync({
        entityName: APPOINTMENT_TASK_ENTITY,
        actionName: APPOINTMENT_TASK_ACTIONS.bulkDeactivate,
        selectedIds: appointmentIds,
      });
    },
    [createTaskAsync],
  );

  return {
    submitSendEmail,
    submitDeactivate,
    isPending,
  };
}
